export default __webpack_public_path__ + "static/media/ordinacija_W112-SAFEBOARD.b30b1ec4.jpg";